import { MessageService } from 'primeng/api';

export interface ValidationRule {
  valid: boolean;
  message: string;
  id?: string; // optional identifier for telemetry
}

export interface AggregateValidationOptions {
  prefix?: string;
  warnInsteadOfError?: boolean;
  separator?: string;
  dedupe?: boolean;
  silent?: boolean; // if true, do not toast – still returns boolean
}

export const VALIDATION_PREFIX = 'Please correct the following:';

export function aggregateValidation(msg: MessageService, rules: ValidationRule[], opts: AggregateValidationOptions = {}): boolean {
  const failed = (opts.dedupe ? dedupeRules(rules) : rules).filter((r) => !r.valid);
  if (!failed.length) return true;
  if (!opts.silent) {
    const detail = `${opts.prefix || VALIDATION_PREFIX} ${failed.map((f) => f.message).join(opts.separator || ' | ')}`;
    msg.add({ severity: opts.warnInsteadOfError ? 'warn' : 'error', summary: 'Validation', detail });
  }
  return false;
}

function dedupeRules(rules: ValidationRule[]): ValidationRule[] {
  const seen = new Set<string>();
  const result: ValidationRule[] = [];
  for (const r of rules) {
    const key = r.message;
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(r);
  }
  return result;
}
